var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"lck-badge",style:({ color: _vm.color, backgroundColor: _vm.backgroundColor })},[_c('span',{staticClass:"lck-badge-content"},[_vm._v(_vm._s(_vm.label))])])}
var staticRenderFns = []

export { render, staticRenderFns }